module.exports = __webpack_public_path__ + "static/media/adding.d14fc89f.svg";